import { render, staticRenderFns } from "./ForumPage.vue?vue&type=template&id=13d845f3&scoped=true"
import script from "./ForumPage.vue?vue&type=script&lang=js"
export * from "./ForumPage.vue?vue&type=script&lang=js"
import style0 from "./ForumPage.vue?vue&type=style&index=0&id=13d845f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d845f3",
  null
  
)

export default component.exports